import { DocItem } from './components/doc-item';
import styles from './index.module.sass';

export const DocsTab = () => {
    return (
        <div className={styles.root}>
            <DocItem label='счет фактура' onClick={() => {}} date='27.12.2022'/>
            <DocItem label='акт об оказании услуг' onClick={() => {}} date='27.12.2022'/>
            <DocItem label='товарно-транспортная накладная' onClick={() => {}} date='27.12.2022'/>
            <DocItem label='счет' onClick={() => {}} date='27.12.2022'/>
            <DocItem label='спецификация' onClick={() => {}} date='27.12.2022'/>
        </div>
    )
}